export default __webpack_public_path__ + "static/media/tab-ux-black.75f97df0.svg";